// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IContributionRecordDto } from './IContributionRecordDto';
import {
    IContributionRecordDtoFromJSON,
    IContributionRecordDtoFromJSONTyped,
    IContributionRecordDtoToJSON,
    IContributionRecordDtoToJSONTyped,
} from './IContributionRecordDto';

/**
 * 
 * @export
 * @interface IContributionRequestDto
 */
export interface IContributionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionRequestDto
     */
    contribution_id: string;
    /**
     * 
     * @type {Array<IContributionRecordDto>}
     * @memberof IContributionRequestDto
     */
    contribution_record_dtos: Array<IContributionRecordDto>;
}

/**
 * Check if a given object implements the IContributionRequestDto interface.
 */
export function instanceOfIContributionRequestDto(value: object): value is IContributionRequestDto {
    if (!('contribution_id' in value) || value['contribution_id'] === undefined) return false;
    if (!('contribution_record_dtos' in value) || value['contribution_record_dtos'] === undefined) return false;
    return true;
}

export function IContributionRequestDtoFromJSON(json: any): IContributionRequestDto {
    return IContributionRequestDtoFromJSONTyped(json, false);
}

export function IContributionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_id': json['contribution_id'],
        'contribution_record_dtos': ((json['contribution_record_dtos'] as Array<any>).map(IContributionRecordDtoFromJSON)),
    };
}

export function IContributionRequestDtoToJSON(json: any): IContributionRequestDto {
    return IContributionRequestDtoToJSONTyped(json, false);
}

export function IContributionRequestDtoToJSONTyped(value?: IContributionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_id': value['contribution_id'],
        'contribution_record_dtos': ((value['contribution_record_dtos'] as Array<any>).map(IContributionRecordDtoToJSON)),
    };
}

